<script setup lang="ts">
import { PrimaryButton } from '@hfc/ui-core';
import { CarrierPageData } from '@/page/domain/CarrierPageData';

defineProps<{
  carrierData: Partial<CarrierPageData>;
}>();
</script>

<template>
  <div class="w-full bg-slate-100 py-16">
    <div class="flex flex-1 flex-col items-center max-w-7xl mx-auto relative space-y-6 px-6">
      <h2 :class="carrierData.textDirection ? carrierData.textDirection : 'text-center'" class="text-center text-2xl lg:text-3xl" v-html="carrierData.title"></h2>
      <div v-html="carrierData.content"></div>
      <div class="flex flex-col md:flex-row space-y-16 md:space-y-0 lg:space-x-16 py-4">
        <div v-for="question in carrierData.subContent" :key="question.title" class="flex flex-col items-center text-center space-y-3 w-44">
          <h2>{{ question.title }}</h2>
          <div class="flex font-bold">{{ question.content }}</div>
        </div>
      </div>
      <PrimaryButton v-if="carrierData.redirectUrl" class="text-sm uppercase" size="lg" :href="carrierData.redirectUrl" target="_blank">
        {{ carrierData.redirectButtonText }}
      </PrimaryButton>
    </div>
  </div>
</template>
